import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CmsCta } from 'components/CmsPage/modules/CmsCta';
import { ga } from 'helpers/multitrack';
export var UserQuote =
/*#__PURE__*/
function (_Component) {
  _inherits(UserQuote, _Component);

  function UserQuote(props) {
    var _this;

    _classCallCheck(this, UserQuote);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserQuote).call(this, props));
    _this.handleCtaClick = _this.handleCtaClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UserQuote, [{
    key: "handleCtaClick",
    value: function handleCtaClick() {
      ga('User Quote Module', 'Clicked CTA');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          author = _this$props.author,
          copy = _this$props.copy,
          cta = _this$props.cta,
          desktopImage = _this$props.desktopImage,
          location = _this$props.location,
          mediaQuerySm = _this$props.mediaQuerySm,
          mobileImage = _this$props.mobileImage,
          theme = _this$props.theme,
          title = _this$props.title;
      return React.createElement("div", {
        className: "user-quote"
      }, React.createElement("div", {
        className: "user-quote__placeholder",
        style: {
          backgroundImage: "url(".concat(mediaQuerySm ? desktopImage : mobileImage, ")")
        }
      }), React.createElement("div", {
        className: "user-quote__content user-quote__content--".concat(theme)
      }, React.createElement("blockquote", {
        className: "user-quote__content__text"
      }, React.createElement("h2", null, title), React.createElement("p", {
        className: "text--lg"
      }, copy), React.createElement("footer", null, React.createElement("cite", {
        className: "text--md text--bold"
      }, author), React.createElement("p", {
        className: "text--xs"
      }, location))), cta && React.createElement("div", {
        className: "user-quote__content__cta"
      }, React.createElement(CmsCta, _extends({}, cta, {
        onClick: this.handleCtaClick
      })))));
    }
  }]);

  return UserQuote;
}(Component);
UserQuote.propTypes = {
  author: PropTypes.string,
  copy: PropTypes.string,
  cta: PropTypes.object,
  desktopImage: PropTypes.string.isRequired,
  location: PropTypes.string,
  mediaQuerySm: PropTypes.bool,
  mobileImage: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['dark', 'light']).isRequired,
  title: PropTypes.string.isRequired
};